import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src348838661/src/main_website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src348838661/src/main_website/node_modules/next/dist/client/image-component.js");
